export function groupAndSortByGroupAndOrder(config) {
  const grouped = {
    mainVA: {
      visible: true,
      keys: [],
    },
    secondaryVA: {
      visible: false,
      keys: [],
    },
    mainLead: {
      visible: true,
      keys: [],
    },
    secondaryLead: {
      visible: false,
      keys: [],
    },
    others: {
      visible: false,
      keys: [],
    },
  }
  Object.entries(config).forEach(([key, value]) => {
    const { group, order } = value
    if (!grouped[group]) return
    grouped[group].keys.push({ key, order })
  })
  Object.keys(grouped).forEach(group => {
    grouped[group].keys.sort((a, b) => a.order - b.order)
    grouped[group].keys = grouped[group].keys.map(item => item.key)
  })
  return grouped
}
